import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteCircuit } from '../../../../actions';

const CircuitDeleteButton = ({
  dispatchDeleteCircuit,
  circuitId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteCircuit({ circuitId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

CircuitDeleteButton.propTypes = {
  dispatchDeleteCircuit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  circuitId: PropTypes.number.isRequired,
};

CircuitDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteCircuit: deleteCircuit,
};

export default connect(null, mapDispatchToProps)(CircuitDeleteButton);
